<template>

    <Toast/>

    <MenuSiCompact/>

    <div class="px-6 surface-overlay relative">

        <ul class="list-none py-2 px-0 m-0 flex align-items-center font-medium overflow-x-auto w-full">
            <li class="pr-3"><a @click="processHome" class="cursor-pointer"><i class="pi pi-home text-text-900"></i></a>
            </li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a @click="processSetGoals" class="cursor-pointer text-900 white-space-nowrap">Plan</a></li>
            <li class="px-2"><i class="pi pi-angle-right text-900"></i></li>
            <li class="px-2"><a class="cursor-pointer text-900 white-space-nowrap">Alerts</a></li>
        </ul>

        <div style="height: 8px;"></div>

        <div class="grid">
            <div class="col-12">
                <span>
                    Create, configure, or delete your alerts.
                </span>
            </div>
        </div>

        <div v-show="activeTab === 1" class="grid">

            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div class="field">
                        <span>Functionality not available with current subscription. Please upgrade to view functionality.</span>
                    </div>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <div style="height: 20px;"></div>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewAlert" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Alert</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="alerts"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        responsiveLayout="scroll">

                        <template #empty>
                            No alerts found.
                        </template>

                        <template #loading>
                            Loading alerts. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1"
                                        :loading="submitted" @click="callUpdateAlert(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        :loading="submitted" @click="callDeleteAlert(data)"/>

                                <Button v-tooltip="'Configure'" icon="pi pi-eye"
                                        class="p-button-rounded p-button-info m-1"
                                        :loading="submitted" @click="callConfigureAlert(data)"/>
                            </template>
                        </Column>

                        <Column field="name" header="Name" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Name</span>
                                {{ data.name }}
                            </template>
                        </Column>

                        <Column field="exchange" header="Exchange" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Exchange</span>
                                {{ data.exchange }}
                            </template>
                        </Column>

                        <Column field="code" header="Stock Symbol" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Stock Symbol</span>
                                {{ data.code }}
                            </template>
                        </Column>

                        <Column field="status" header="Status" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Status</span>
                                <span v-if="data.status === 'I'"
                                      :class="'status-badge status-' + data.status">Inactive</span>
                                <span v-if="data.status === 'A'"
                                      :class="'status-badge status-' + data.status">Active</span>
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Alert</h3>

                    <div class="field">
                        <label for="name">Name of Alert</label>
                        <InputText
                            id="name"
                            v-model.trim="newAlert.name"
                            required="true"
                            :class="{ 'p-invalid': submitted && !newAlert.name }"/>
                    </div>

                    <div class="field">
                        <label for="status">Exchange</label>
                        <Dropdown v-model="newAlert.exchange" :options="exchanges"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"
                                  :class="{ 'p-invalid': submitted && !newAlert.exchange }" />
                    </div>

                    <div class="field">
                        <label for="client">Company Name</label>
                        <AutoComplete
                            placeholder="Search by stock symbol or company name"
                            :dropdown="true"
                            :multiple="false"
                            v-model="newAlert.code"
                            :suggestions="filteredCodes"
                            @complete="searchCodes($event)"
                            field="label"
                            :class="{ 'p-invalid': submitted && !newAlert.code }"
                        />
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :disabled="isAlertCreateDisabled" @click="createAlert"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Alert</h3>

                    <div class="field">
                        <label for="name">Name</label>
                        <InputText id="name" v-model.trim="alert.name" required="true"/>
                    </div>

                    <div class="field">
                        <label for="exchange">Exchange</label>
                        <InputText id="name" v-model.trim="alert.exchange" required="true" disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="code">Code</label>
                        <InputText id="code" v-model.trim="alert.code" required="true" disabled="true"/>
                    </div>

                    <div class="field">
                        <label for="status">Status</label>
                        <Dropdown v-model="alert.status" :options="statusTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateAlert"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Alert</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Alert?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteAlert"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Configure Alert {{ this.alert.name }}</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callNewAlertComponent" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Custom Filter Component</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callToOverview" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Alerts</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable
                        :value="alertComponents"
                        :paginator="true"
                        class="p-datatable-gridlines"
                        :rows="100"
                        dataKey="id"
                        :rowsPerPageOptions="[10,20,50,100]"
                        :rowHover="true"
                        :striped-rows="true"
                        :reorderableColumns="true"
                        :sortMode="'multiple'"
                        responsiveLayout="scroll">

                        <template #empty>
                            No alert components found.
                        </template>

                        <template #loading>
                            Loading alert components. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1"
                                        :loading="submitted" @click="callUpdateAlertComponent(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        :loading="submitted" @click="callDeleteAlertComponent(data)"/>
                            </template>
                        </Column>

                        <Column field="code" header="Name" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Name</span>
                                {{ getStockCodeName(data.item) }}
                            </template>
                        </Column>

                        <Column field="operator" header="Operator" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Operator</span>
                                <span v-if="data.operator === 'E'"
                                      :class="'status-badge status-' + data.operator">Equal</span>
                                <span v-if="data.operator === 'N'"
                                      :class="'status-badge status-' + data.operator">Not Equal</span>
                                <span v-if="data.operator === 'G'"
                                      :class="'status-badge status-' + data.operator">Greater Than</span>
                                <span v-if="data.operator === 'L'"
                                      :class="'status-badge status-' + data.operator">Less Than</span>
                                <span v-if="data.operator === 'H'"
                                      :class="'status-badge status-' + data.operator">Greater Than or Equal To</span>
                                <span v-if="data.operator === 'M'"
                                      :class="'status-badge status-' + data.operator">Less Than or Equal To</span>
                            </template>
                        </Column>

                        <Column field="value" header="Value" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">value</span>
                                {{ data.value }}
                            </template>
                        </Column>

                        <Column field="closingOperator" header="Closing Operator" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Operator</span>
                                <span v-if="data.closingOperator === 'A'"
                                      :class="'status-badge status-' + data.closingOperator">And</span>
                                <span v-if="data.closingOperator === 'O'"
                                      :class="'status-badge status-' + data.closingOperator">Or</span>
                            </template>
                        </Column>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Alert Component</h3>

                    <div class="field">
                        <label for="code">Name</label>
                        <Dropdown
                            v-model="newAlertComponent.item"
                            :options="stockCodes"
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select an Option"
                            filter
                        />
                    </div>

                    <div class="field">
                        <label for="operator">Operator</label>
                        <Dropdown v-model="newAlertComponent.operator" :options="operators"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="newAlertComponent.value" required="true"/>
                    </div>

                    <div class="field">
                        <label for="operator">Closing Operator</label>
                        <Dropdown v-model="newAlertComponent.closingOperator" :options="closingOperators"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" @click="createAlertComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 8" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Alert Component</h3>

                    <div class="field">
                        <label for="code">Name</label>
                        <Dropdown
                            v-model="alertComponent.item"
                            :options="stockCodes"
                            optionLabel="name"
                            optionValue="code"
                            placeholder="Select an Option"
                            filter
                        />
                    </div>

                    <div class="field">
                        <label for="operator">Operator</label>
                        <Dropdown v-model="alertComponent.operator" :options="operators"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="field">
                        <label for="value">Value</label>
                        <InputText id="value" v-model.trim="alertComponent.value" required="true"/>
                    </div>

                    <div class="field">
                        <label for="operator">Closing Operator</label>
                        <Dropdown v-model="alertComponent.closingOperator" :options="closingOperators"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" @click="updateAlertComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Alert Component {{ this.alertComponent.code }}</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Alert Component?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" @click="deleteAlertComponent"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" @click="callToOverview"></Button>

                </div>
            </div>
        </div>

    </div>

    <SiFooter/>

</template>

<script>
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import CompanyService from "@/service/CompanyService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import AlertService from "@/service/AlertService";
import AlertComponentService from "@/service/AlertComponentService";
import SiFooter from "@/components/heading/authentication/SiFooter.vue";
import StockService from "@/service/StockService";
import MenuSiCompact from "@/components/simodule/MenuSiCompact.vue";

export default {
    components: {
        MenuSiCompact,
        SiFooter
    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },
    created() {
        this.initFilters();

        this.columnsDefault = [
            {field: 'code', header: 'Symbol', sortable: true},
            {field: 'condition', header: 'Condition', sortable: true}
        ];

        this.columnsFullList = [
            {field: 'code', header: 'Symbol', sortable: true},
            {field: 'condition', header: 'Condition', sortable: true}
        ];

        this.selectedColumns = this.columnsDefault;

        this.standardFilters = [
            {field: 'recent', header: 'Recent'}
        ];
    },
    computed: {
        isAlertCreateDisabled() {
            const a = this.newAlert;
            return !a.name || !a.exchange || !a.code;
        }
    },
    async mounted() {
        try {
            const [userData, userConfigData] = await Promise.all([
                UserService.getUser(this.userStore.user.id),
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.profile = userData.data;
            this.userConfig = userConfigData.data;

            if (this.profile.rights === 'C') {
                this.activeTab = 1;
            } else {
                this.activeTab = 2;
            }

            if (this.userConfig.enableSiUs === 'Y') {
                var newEntry1 = {name: 'NYSE', code: 'NYSE'};
                var newEntry2 = {name: 'NASDAQ', code: 'NASDAQ'};

                this.exchanges.push(newEntry1);
                this.exchanges.push(newEntry2);
            }

            if (this.userConfig.enableSiCa === 'Y') {
                var newEntry3 = {name: 'TSX', code: 'TO'};

                this.exchanges.push(newEntry3);
            }

            if (this.userConfig.enableSiUk === 'Y') {
                var newEntry4 = {name: 'LSE', code: 'LSE'};
                this.exchanges.push(newEntry4);
            }

            if (this.userConfig.enableSiZa === 'Y') {
                var newEntry5 = {name: 'JSE', code: 'JSE'};
                this.exchanges.push(newEntry5);
            }

            console.log("[Overview][mounted] this.exchanges = ", this.exchanges);

        } catch (e) {
            console.error("[ConfigurationAlerts][mounted] Error fetching user data = ", e);
            this.userStore.clearUser();
            // this.$router.push("login");
            this.$router.replace('/siLogin');
            return;
        }

        try {
            const [userConfigData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id)
            ]);

            this.userConfiguration = userConfigData.data;
            console.log("[ConfigurationAlerts][mounted] userConfigData.data = ", userConfigData.data);
        } catch (e) {
            console.error("[ConfigurationAlerts][mounted] Could not find user config for user = ", this.userStore.user.id);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        try {
            const [companyConfigData] = await Promise.all([
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.companyConfiguration = companyConfigData.data;
            console.log("[ConfigurationAlerts][mounted] companyConfigData.data = ", companyConfigData.data);

            this.loading = false;

        } catch (e) {
            console.error("[ConfigurationAlerts][mounted] Error fetching additional data = ", e);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

        console.log("[ConfigurationAlerts][mounted] this.userConfiguration = ", this.userConfiguration);
        console.log("[ConfigurationAlerts][mounted] this.companyConfiguration = ", this.companyConfiguration);

        try {
            const [alertsInfo] = await Promise.all([
                AlertService.getUserAlerts(this.userStore.user.id)
            ]);

            this.alerts = alertsInfo.data;
            console.log("[ConfigurationAlerts][mounted] this.alerts = ", this.alerts);

        } catch (e) {
            console.error("[ConfigurationAlerts][mounted] Error fetching filter data = ", e);

            if (e.response && e.response.status === 401) {
                console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                // this.$router.push('/siLogin'); // Redirect to the specified login route
                this.$router.replace('/siLogin');
            } else {
                // Handle other errors (e.g., network issues)
                this.userStore.clearUser();
                // this.$router.push('login'); // This is your existing fallback redirect
                this.$router.replace('/siLogin');
            }
            return;
        }

    },
    data() {

        return {
            profile: {},
            activeTab: 1,
            companyConfiguration: {},
            submitted: false,
            filteredCodes: [],
            activeAlerts: [],
            alerts: [],
            alert: {},
            newAlert: {},
            alertComponents: [],
            alertComponent: {},
            newAlertComponent: {},
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            filters: null,
            loading: true,
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            statusTypes: [
                {name: 'Active', code: 'A'},
                {name: 'Inactive', code: 'I'}
            ],
            operators: [
                {name: 'Equal', code: 'E'},
                {name: 'Not Equal', code: 'N'},
                {name: 'Greater Than', code: 'G'},
                {name: 'Less Than', code: 'L'},
                {name: 'Greater Than or Equal To', code: 'H'},
                {name: 'Less Than or Equal To', code: 'M'}
            ],
            closingOperators: [
                {name: 'And', code: 'A'},
                {name: 'Or', code: 'O'}
            ],
            regionTypes: [
                {name: 'United Kingdom', code: 'UK'},
                {name: 'South Africa', code: 'ZA'},
                {name: 'Canada', code: 'CA'},
                {name: 'United States', code: 'US'},
                {name: 'India', code: 'IN'}
            ],
            exchanges: [],
            stockCodes: [
                {name: '52wk High', code: 'hspWeek52Id001'},
                {name: '52wk Low', code: 'lspWeek52Id002'},
                {name: 'Altman Z-Score', code: 'altmanZscoreId003'},
                {name: 'Annual Fwd Dividend', code: 'afdId004'},
                {name: 'R9 - Fwd Dividend vs Prev Year', code: 'afdPreviousId005'},
                {name: 'R6 - Avg Div Growth 5yr', code: 'adgYear5Id006'},
                {name: 'R6 - Avg Div Growth 10yr', code: 'adgYear10Id007'},
                {name: 'R6 - Avg Div Growth 15yr', code: 'adgYear15Id008'},
                {name: 'R6 - Avg Div Growth 20yr', code: 'adgYear20Id009'},
                {name: 'Avg Div Yld 5yr', code: 'adyYear5Id010'},
                {name: 'Avg Div Yld 10yr', code: 'adyYear10Id011'},
                {name: 'Avg Div Yld 15yr', code: 'adyYear15Id012'},
                {name: 'Avg Div Yld 20yr', code: 'adyYear20Id013'},
                {name: 'Avg 3yr EPS', code: 'averageEpsYear3Id014'},
                {name: 'R5a - Avg EPS Growth 5yr', code: 'averageEpsGrowthYear5Id015'},
                {name: 'R5a - Avg EPS Growth 10yr', code: 'averageEpsGrowthYear10Id016'},
                {name: 'R5a - Avg EPS Growth 15yr', code: 'averageEpsGrowthYear15Id017'},
                {name: 'R5a - Avg EPS Growth 20yr', code: 'averageEpsGrowthYear20Id018'},
                {name: 'Avg High Div Yld 5yr', code: 'averageHdyYear5Id019'},
                {name: 'Avg High Div Yld 10yr', code: 'averageHdyYear10Id020'},
                {name: 'Avg High Div Yld 15yr', code: 'averageHdyYear15Id021'},
                {name: 'Avg High Div Yld 20yr', code: 'averageHdyYear20Id022'},
                {name: 'Avg High P/E 5yr', code: 'averageHighPeRatioYear5Id023'},
                {name: 'Avg High P/E 10yr', code: 'averageHighPeRatioYear10Id024'},
                {name: 'Avg High P/E 15yr', code: 'averageHighPeRatioYear15Id025'},
                {name: 'Avg High P/E 20yr', code: 'averageHighPeRatioYear20Id026'},
                {name: 'Avg Low Div Yld 5yr', code: 'averageLdyYear5Id027'},
                {name: 'Avg Low Div Yld 10yr', code: 'averageLdyYear10Id028'},
                {name: 'Avg Low Div Yld 15yr', code: 'averageLdyYear15Id029'},
                {name: 'Avg Low Div Yld 20yr', code: 'averageLdyYear20Id030'},
                {name: 'Avg Low P/E 5yr', code: 'averageLowPeRatioYear5Id031'},
                {name: 'Avg Low P/E 10yr', code: 'averageLowPeRatioYear10Id032'},
                {name: 'Avg Low P/E 15yr', code: 'averageLowPeRatioYear15Id033'},
                {name: 'Avg Low P/E 20yr', code: 'averageLowPeRatioYear20Id034'},
                {name: 'Avg P/E 5yr', code: 'averagePeRatioYear5Id035'},
                {name: 'Avg P/E 10yr', code: 'averagePeRatioYear10Id036'},
                {name: 'Avg P/E 15yr', code: 'averagePeRatioYear15Id037'},
                {name: 'Avg P/E 20yr', code: 'averagePeRatioYear20Id038'},
                {name: 'Bk Value/Share', code: 'bookValuePerShareId039'},
                {name: 'Cashflow/Share', code: 'cashFlowPerShareId040'},
                {name: 'City', code: 'companyAddressCityId041'},
                {name: 'Country', code: 'companyAddressCountryId042'},
                {name: 'State/Prov', code: 'companyAddressStateId043'},
                {name: 'Address', code: 'companyAddressId044'},
                {name: 'Description', code: 'companyDescriptionId045'},
                {name: 'Name', code: 'companyNameId046'},
                {name: 'Consecutive Yrs Div Increases', code: 'yearsDividendIncreasesId047'},
                {name: 'Consecutive Yrs EPS Increases', code: 'yearsEpsIncreasesId048'},
                {name: 'Current Assets', code: 'currentAssetsId049'},
                {name: 'Current Div Yld', code: 'currentDividendYieldId050'},
                {name: 'Current Debt', code: 'currentLiabilitiesId051'},
                {name: 'Current Ratio', code: 'currentRatioId052'},
                {name: 'Diff Between Current Div Yld & Avg Div Yld 5yrs', code: 'diffDyCurrentVsAverageYear5Id053'},
                {name: 'Diff Between Current Div Yld & Avg Div Yld 10yrs', code: 'diffDyCurrentVsAverageYear10Id054'},
                {name: 'Diff Between Current Div Yld & Avg Div Yld 15yrs', code: 'diffDyCurrentVsAverageYear15Id055'},
                {name: 'Diff Between Current Div Yld & Avg Div Yld 20yrs', code: 'diffDyCurrentVsAverageYear20Id056'},
                {name: 'Diff Between Current P/E & Avg P/E 5yrs', code: 'diffPeCurrentVsAverageYear5Id057'},
                {name: 'Diff Between Current P/E & Avg P/E 10yrs', code: 'diffPeCurrentVsAverageYear10Id058'},
                {name: 'Diff Between Current P/E & Avg P/E 15yrs', code: 'diffPeCurrentVsAverageYear15Id059'},
                {name: 'Diff Between Current P/E & Avg P/E 20yrs', code: 'diffPeCurrentVsAverageYear20Id060'},
                {name: 'DCF', code: 'dcfId061'},
                {name: 'Div Currency', code: 'dividendCurrencyId062'},
                {name: 'Div Frequency', code: 'dividendFrequencyId063'},
                {name: 'Div Gr (5yr) + Curr Div Yld', code: 'dgPlusDyYear5Id064'},
                {name: 'Div Gr (10yr) + Curr Div Yld', code: 'dgPlusDyYear10Id065'},
                {name: 'Div Gr (15yr) + Curr Div Yld', code: 'dgPlusDyYear15Id066'},
                {name: 'Div Gr (20yr) + Curr Div Yld', code: 'dgPlusDyYear20Id067'},
                {name: 'Div Payment Date', code: 'dividendPaymentDateId068'},
                {name: 'Div Record Date', code: 'dividendRecordDateId069'},
                {name: 'Divs Paid Since', code: 'dividendPaidId070'},
                {name: 'EPS (TTM)', code: 'epsTtmId071'},
                {name: 'ESG Score', code: 'esgScoreId072'},
                {name: 'Exchange', code: 'exchangeId073'},
                {name: 'Ex-Div Date', code: 'exDividendDateId074'},
                {name: 'Fiscal Yr End', code: 'fiscalYearendDateId075'},
                {name: 'Graham Price', code: 'grahamPriceId076'},
                {name: 'High Price Using 5yr Data', code: 'hspYear5Id077'},
                {name: 'High Price Using 10yr Data', code: 'hspYear10Id078'},
                {name: 'High Price Using 15yr Data', code: 'hspYear15Id079'},
                {name: 'High Price Using 20yr Data', code: 'hspYear20Id080'},
                {name: 'Industry', code: 'industryId081'},
                {name: 'LT Debt', code: 'longtermDebtId082'},
                {name: 'LT Debt/Total Capital', code: 'longtermDebtVsTotalCapitalId083'},
                {name: 'R8 - LT Debt/Equity', code: 'longtermDebtEquityRatioId084'},
                {name: 'Low Price Using 5yr Data', code: 'lspYear5Id085'},
                {name: 'Low Price Using 10yr Data', code: 'lspYear10Id086'},
                {name: 'Low Price Using 15yr Data', code: 'lspYear15Id087'},
                {name: 'Low Price Using 20yr Data', code: 'lspYear20Id088'},
                {name: 'Market/Country', code: 'marketId089'},
                {name: 'Market Cap', code: 'marketCapitalisationId090'},
                {name: 'Net Income', code: 'netIncomeId091'},
                {name: 'Net Income/Share TTM', code: 'netIncomePerShareId092'},
                {name: 'Employees', code: 'employeesId093'},
                {name: 'R5b - EPS Increases in 5yrs', code: 'epsIncreasesYear5Id094'},
                {name: 'R5b - EPS Increases in 10yrs', code: 'epsIncreasesYear10Id095'},
                {name: 'R5b - EPS Increases in 15yrs', code: 'epsIncreasesYear15Id096'},
                {name: 'R5b - EPS Increases in 20yrs', code: 'epsIncreasesYear20Id097'},
                {name: 'Share Outstanding', code: 'outstandingSharesCurrentYearId098'},
                {name: 'Share Outstanding (previous Yr) ', code: 'outstandingSharesPreviousYearId099'},
                {name: 'Operating Cashflow', code: 'operatingCashflowId100'},
                {name: 'Operating Cashflow Ratio', code: 'operatingCashflowRatioId101'},
                {name: 'R11c - P/B Ratio', code: 'pbRatioId102'},
                {name: 'P/CF Ratio', code: 'pcfRatioId103'},
                {name: 'R11a - P/E Ratio TTM', code: 'peRatioId104'},
                {name: 'P/FCF Ratio', code: 'pfcfRatioId105'},
                {name: 'P/S Ratio', code: 'psRatioId106'},
                {name: 'R7 - Payout Ratio', code: 'payoutRatioId107'},
                {name: 'PEG Ratio Using Avg EPS Growth 5yr', code: 'pegRatioYear5Id108'},
                {name: 'PEG Ratio Using Avg EPS Growth 10yr', code: 'pegRatioYear10Id109'},
                {name: 'PEG Ratio Using Avg EPS Growth 15yr', code: 'pegRatioYear15Id110'},
                {name: 'PEG Ratio Using Avg EPS Growth 20yr', code: 'pegRatioYear20Id111'},
                {name: '% diff Graham Price vs Share Price', code: 'diffGrahamPriceSharePriceId112'},
                {name: '% Owned by Institutions', code: 'sharesOwnedInstitutionsId113'},
                {name: 'Piotroski F-Score', code: 'piotroskiFscoreId114'},
                {name: 'Total Operating Profit Margin', code: 'profitMarginId115'},
                {name: 'Quick Ratio', code: 'quickRatioId116'},
                {name: 'Recent Div Payment', code: 'recentDividendPaymentId117'},
                {name: 'ROA TTM', code: 'roaTtmId118'},
                {name: 'ROC TTM', code: 'rocTtmId119'},
                {name: 'ROE TTM', code: 'roeTtmId120'},
                {name: 'Sector', code: 'sectorId121'},
                {name: 'R10 - Share Buyback?', code: 'shareBuybackId122'},
                {name: 'Share Price', code: 'sharePriceId123'},
                {name: 'Share Date & Time', code: 'sharePriceDateId124'},
                {name: 'SI Criteria out of 10 (5yr Data)', code: 'siCriteriaYear5Id125'},
                {name: 'SI Criteria out of 10 (10yr Data)', code: 'siCriteriaYear10Id126'},
                {name: 'SI Criteria out of 10 (15yr Data)', code: 'siCriteriaYear15Id127'},
                {name: 'SI Criteria out of 10 (20yr Data)', code: 'siCriteriaYear20Id128'},
                {name: 'Stock Symbol', code: 'codeId129'},
                {name: 'Total Debt/Equity Ratio', code: 'totalDebtVsEquityRatioId130'},
                {name: 'Total Stockholder Equity', code: 'totalStockholderEquityId131'},
                {name: 'R11b - Under/Over Valued Using 5yr Data', code: 'undervaluedVsOvervaluedStatusYear5Id132'},
                {name: 'R11b - Under/Over Valued Using 10yr Data', code: 'undervaluedVsOvervaluedStatusYear10Id133'},
                {name: 'R11b - Under/Over Valued Using 15yr Data', code: 'undervaluedVsOvervaluedStatusYear15Id134'},
                {name: 'R11b - Under/Over Valued Using 20yr Data', code: 'undervaluedVsOvervaluedStatusYear20Id135'},
                {name: 'Website', code: 'websiteId136'},
            ]
        }
    },
    methods: {
        closeAllMenus() {
            document.body.click(); // triggers hideOnOutsideClick

            document.querySelectorAll('.p-component-overlay, .p-menu-overlay, .p-overlay, .p-tieredmenu-overlay')
                .forEach(el => el.remove());
        },
        safeNavigate(target) {
            this.closeAllMenus();
            setTimeout(() => {
                this.$router.push(target);
            }, 0);
        },
        processHome() {
            console.log("[MenuConfiguration][processHome] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siHome');
        },
        processSetGoals() {
            console.log("[MenuConfiguration][processSetGoals] Beginning.");
            this.closeAllMenus();
            this.safeNavigate('/siSetGoals');
        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'code': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'condition': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        clearFilter() {
            this.initFilters();
        },
        restoreToOriginal() {
            window.location.reload();
        },
        callReset() {
            this.activeTab = 1;
        },
        callOverview() {
            this.$router.push("siOverview");
        },
        getStockCodeName(item) {
            const stock = this.stockCodes.find(stock => stock.code === item);
            return stock ? stock.name : 'Unknown Code';
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        onToggleStandardFilters(value) {

            if (value.length > 1) {
                // Keep the last selected option
                this.selectedStandardFilter = [value[value.length - 1]];
            } else {
                this.selectedStandardFilter = value;
            }

            const isRecent = value.some(item => item.field === "recent");

            if (this.alerts !== null) {

                if (isRecent) {
                    this.alerts = this.originalAlerts.filter(alert => alert.type === 'B');
                } else {
                    this.alerts = this.originalAlerts;
                }

            } else {
                this.alerts = null;
            }
        },
        searchCodes(event) {
            console.log("[ConfigurationAlerts][searchCodes] event.query = ", event.query);
            console.log("[ConfigurationAlerts][searchCodes] this.newAlert.exchange = ", this.newAlert.exchange);
            console.log("[ConfigurationAlerts][searchCodes] this.newAlert.code = ", this.newAlert.code);

            StockService.searchStocksForExchangeByName(this.newAlert.exchange, event.query.toLowerCase())
                .then(data => {
                    // this.filteredCodes = data.data;
                    this.filteredCodes = data.data.map(stock => ({
                        label: `${stock.name} (${stock.code})`,
                        value: stock.code // or the entire stock object, depending on your needs
                    }));
                    console.log("[ConfigurationAlerts][searchCodes] Got client data = ", data.data);
                })
                .catch(e => {
                    console.log("[ConfigurationAlerts][searchCodes] Error = ", e);

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                });

        },
        async updateConfiguration() {

            var updatedConfiguration = {
                region: this.companyConfiguration.region,
                type: this.companyConfiguration.type,
                practitionerType: this.companyConfiguration.practitionerType,
                requirePhone: this.companyConfiguration.requirePhone,
                requireWebsite: this.companyConfiguration.requireWebsite,
                website: this.companyConfiguration.website,
                qualification: this.companyConfiguration.qualification,
                registrationNumber: this.companyConfiguration.registrationNumber,
                practiceNumber: this.companyConfiguration.practiceNumber,
                enableRemindersEmail: this.companyConfiguration.enableRemindersEmail,
                enableRemindersSms: this.companyConfiguration.enableRemindersSms,
                enableRemindersWhatsapp: this.companyConfiguration.enableRemindersWhatsapp,
                enableRemindersPhone: this.companyConfiguration.enableRemindersPhone
            };

            console.log("[" + name + "][processUpdateConfiguration] Updated configuration. Data = ", updatedConfiguration);

            this.activeTab = 2;

            try {
                // Delete the appointment
                const response = await CompanyService.updateCompanyConfiguration(this.profile.companyId, updatedConfiguration);
                console.log('[PhoneCalls][deletePhoneCall] Response = ', response);

                const [companyConfigData] = await Promise.all([
                    CompanyService.getCompanyConfiguration(this.profile.companyId)
                ]);

                this.companyConfiguration = companyConfigData.data;
                console.log("[PhoneCalls][mounted] companyConfigData.data = ", companyConfigData.data);

                if (this.companyConfiguration.manualClientIntakeForms == null) {
                    this.companyConfiguration.manualClientIntakeForms = 'Y';
                }

                if (this.companyConfiguration.manualBillingInstructions == null) {
                    this.companyConfiguration.manualBillingInstructions = 'Y';
                }

                if (this.companyConfiguration.weeklyNewClients == null) {
                    this.companyConfiguration.weeklyNewClients = 1;
                }

                if (this.companyConfiguration.weeklyWorkingDays == null) {
                    this.companyConfiguration.weeklyWorkingDays = 4;
                }

                if (this.companyConfiguration.weeklyBillableAppointments == null) {
                    this.companyConfiguration.weeklyBillableAppointments = 3;
                }

                if (this.companyConfiguration.clientSplit == null) {
                    this.companyConfiguration.clientSplit = 80;
                }

                if (this.companyConfiguration.monthlyBankStatements == null) {
                    this.companyConfiguration.monthlyBankStatements = 1;
                }

                if (this.companyConfiguration.bankStatementSize == null) {
                    this.companyConfiguration.bankStatementSize = 3;
                }

                if (this.companyConfiguration.monthlyRemittances == null) {
                    this.companyConfiguration.monthlyRemittances = 4;
                }

                if (this.companyConfiguration.remittanceSize == null) {
                    this.companyConfiguration.remittanceSize = 2;
                }

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Configuration updated',
                    life: 3000
                });

            } catch (e) {
                console.error('[PhoneCalls][deletePhoneCall] Error:', e);

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update configuration. Please try again.',
                    life: 3000
                });

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        },
        callNewAlert() {
            this.newAlert = {};

            if (this.exchanges && this.exchanges.length > 0) {
                this.newAlert.exchange = this.exchanges[0].code;
            }

            this.activeTab = 3;
        },
        callUpdateAlert(data) {
            this.alert = data;
            this.activeTab = 4;
        },
        callDeleteAlert(data) {
            this.alert = data;
            this.confirmationResponse = 'N';
            this.activeTab = 5;
        },
        async callConfigureAlert(data) {
            this.alert = data;
            this.activeTab = 6;

            console.log("[Overview][callConfigureCustomFilter] this.alert = ", this.alert);

            try {
                const [alertComponentsInfo] = await Promise.all([
                    AlertComponentService.getAlertComponentsForAlert(this.alert.id)
                ]);

                this.alertComponents = alertComponentsInfo.data;
                console.log("[Overview][callConfigureCustomFilter] this.alertComponents = ", this.alertComponents);

            } catch (e) {
                console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                if (e.response && e.response.status === 401) {
                    console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                    // this.$router.push('/siLogin'); // Redirect to the specified login route
                    this.$router.replace('/siLogin');
                } else {
                    // Handle other errors (e.g., network issues)
                    this.userStore.clearUser();
                    // this.$router.push('login'); // This is your existing fallback redirect
                    this.$router.replace('/siLogin');
                }
                return;
            }

        },
        callNewAlertComponent() {
            this.newAlertComponent = {};
            this.newAlertComponent.operator = 'E';
            this.newAlertComponent.closingOperator = 'A';
            this.activeTab = 7;
        },
        callUpdateAlertComponent(data) {
            this.alertComponent = data;
            this.activeTab = 8;
        },
        callDeleteAlertComponent(data) {
            this.alertComponent = data;
            this.confirmationResponse = 'N';
            this.activeTab = 9;
        },
        async createAlert() {
            this.submitted = true;

            console.log('[ConfigurationAlert][createAlert] this.newAlert.name = ', this.newAlert.name);
            console.log('[ConfigurationAlert][createAlert] this.newAlert.exchange = ', this.newAlert.exchange);
            console.log('[ConfigurationAlert][createAlert] this.newAlert.code = ', this.newAlert.code);

            if (this.isAlertCreateDisabled) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please fill in all fields.',
                    life: 3000
                });
                return;

            } else {
                try {
                    var alertDto = {
                        name: this.newAlert.name,
                        exchange: this.newAlert.exchange,
                        code: this.newAlert.code.value,
                        status: 'A'
                    };

                    const response = await AlertService.createAlert(this.userStore.user.id, alertDto);
                    console.log('[ConfigurationAlert][createAlert] Response = ', response);

                    try {
                        const [alertsInfo] = await Promise.all([
                            AlertService.getUserAlerts(this.userStore.user.id)
                        ]);

                        this.alerts = alertsInfo.data;
                        console.log("[ConfigurationAlerts][mounted] this.alerts = ", this.alerts);
                    } catch (e) {
                        console.error("[ConfigurationAlerts][mounted] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created alert',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[ConfigurationAlert][createAlert] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create alert. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 2;
            this.submitted = false;
        },
        async updateAlert() {
            this.submitted = true;

            if (this.alert.id) {

                try {
                    var alertDto = {
                        name: this.alert.name,
                        status: this.alert.status
                    };

                    const response = await AlertService.updateAlert(this.alert.id, alertDto);
                    console.log('[ConfigurationAlert][createAlert] Response = ', response);

                    try {
                        const [alertsInfo, alertsActiveInfo] = await Promise.all([
                            AlertService.getUserAlerts(this.userStore.user.id),
                            AlertService.getUserActiveAlerts(this.userStore.user.id)
                        ]);

                        this.alerts = alertsInfo.data;
                        this.activeAlerts = alertsActiveInfo.data;
                        console.log("[ConfigurationAlerts][mounted] this.alerts = ", this.alerts);
                        console.log("[ConfigurationAlerts][mounted] this.activeAlerts = ", this.activeAlerts);

                    } catch (e) {
                        console.error("[ConfigurationAlerts][mounted] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated alert',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][updateCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update alert. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 2;
            this.submitted = false;
        },
        async deleteAlert() {
            this.submitted = true;

            if (this.alert.id) {

                try {
                    const response = await AlertService.deleteAlert(this.alert.id);
                    console.log('[Overview][deleteCustomFilter] Response = ', response);

                    try {
                        const [alertsInfo, alertsActiveInfo] = await Promise.all([
                            AlertService.getUserAlerts(this.userStore.user.id),
                            AlertService.getUserActiveAlerts(this.userStore.user.id)
                        ]);

                        this.alerts = alertsInfo.data;
                        this.activeAlerts = alertsActiveInfo.data;
                        console.log("[ConfigurationAlerts][mounted] this.alerts = ", this.alerts);
                        console.log("[ConfigurationAlerts][mounted] this.activeAlerts = ", this.activeAlerts);

                    } catch (e) {
                        console.error("[ConfigurationAlerts][mounted] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted alert',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][deleteCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete alert. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 2;
            this.submitted = false;
        },
        async createAlertComponent() {
            this.submitted = true;

            console.log('[Overview][createCustomFilterComponent] this.newAlertComponent = ', this.newAlertComponent);

            if (this.newAlertComponent.item) {

                try {
                    var alertComponentDto = {
                        item: this.newAlertComponent.item,
                        operator: this.newAlertComponent.operator,
                        closingOperator: this.newAlertComponent.closingOperator,
                        value: this.newAlertComponent.value
                        // visible: this.newAlertComponent.visible,
                        // status: this.newAlertComponent.status
                    };

                    console.log('[Overview][createCustomFilterComponent] alertComponentDto = ', alertComponentDto);

                    const response = await AlertComponentService.createAlertComponent(this.alert.id, alertComponentDto);
                    console.log('[Overview][createCustomFilterComponent] Response = ', response);

                    try {
                        const [alertComponentsInfo] = await Promise.all([
                            AlertComponentService.getAlertComponentsForAlert(this.alert.id)
                        ]);

                        this.alertComponents = alertComponentsInfo.data;
                        console.log("[Overview][callConfigureCustomFilter] this.alertComponents = ", this.alertComponents);

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Created alert component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to create alert component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 6;
            this.submitted = false;
        },
        async updateAlertComponent() {
            this.submitted = true;

            if (this.alertComponent.id) {

                try {
                    var alertComponentDto = {
                        item: this.alertComponent.item,
                        operator: this.alertComponent.operator,
                        closingOperator: this.alertComponent.closingOperator,
                        value: this.alertComponent.value
                        // visible: this.alertComponent.visible,
                        // status: this.alertComponent.status
                    };
                    const response = await AlertComponentService.updateAlertComponent(this.alertComponent.id, alertComponentDto);
                    console.log('[ConfigurationAlerts][updateAlertComponent] Response = ', response);

                    try {
                        const [alertComponentsInfo] = await Promise.all([
                            AlertComponentService.getAlertComponentsForAlert(this.alert.id)
                        ]);

                        this.alertComponents = alertComponentsInfo.data;
                        console.log("[ConfigurationAlerts][updateAlertComponent] this.alertComponents = ", this.alertComponents);

                    } catch (e) {
                        console.error("[ConfigurationAlerts][updateAlertComponent] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Updated alert component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[ConfigurationAlerts][updateAlertComponent] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to update alert component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 6;
            this.submitted = false;
        },
        async deleteAlertComponent() {
            this.submitted = true;

            if (this.alertComponent.id) {

                try {
                    const response = await AlertComponentService.deleteAlertComponent(this.alertComponent.id);
                    console.log('[Overview][createCustomFilterComponent] Response = ', response);

                    try {
                        const [alertComponentsInfo] = await Promise.all([
                            AlertComponentService.getAlertComponentsForAlert(this.alert.id)
                        ]);

                        this.alertComponents = alertComponentsInfo.data;
                        console.log("[Overview][callConfigureCustomFilter] this.alertComponents = ", this.alertComponents);

                    } catch (e) {
                        console.error("[Overview][callConfigureCustomFilter] Error fetching filter data = ", e);

                        if (e.response && e.response.status === 401) {
                            console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                            // this.$router.push('/siLogin'); // Redirect to the specified login route
                            this.$router.replace('/siLogin');
                        } else {
                            // Handle other errors (e.g., network issues)
                            this.userStore.clearUser();
                            // this.$router.push('login'); // This is your existing fallback redirect
                            this.$router.replace('/siLogin');
                        }
                        return;
                    }

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Deleted alert component',
                        life: 3000
                    });

                } catch (e) {
                    console.error('[Overview][createCustomFilter] Error:', e);

                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to delete alert component. Please try again.',
                        life: 3000
                    });

                    if (e.response && e.response.status === 401) {
                        console.log("[Applications][mounted] JWT token expired. Redirecting to login.");
                        // this.$router.push('/siLogin'); // Redirect to the specified login route
                        this.$router.replace('/siLogin');
                    } else {
                        // Handle other errors (e.g., network issues)
                        this.userStore.clearUser();
                        // this.$router.push('login'); // This is your existing fallback redirect
                        this.$router.replace('/siLogin');
                    }
                    return;
                }
            }

            this.activeTab = 6;
            this.submitted = false;
        },
        callToOverview() {
            this.activeTab = 2;
        },
    }
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.status-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-DT {
        background: #E5C7BCFF;
        color: #BE5306FF;
    }

    &.status-A {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-Y {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-N {
        background: #FEEDAF;
        color: #8A5340;
    }


    &.status-E {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-N {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-G {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-L {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-H {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-M {
        background: #d9b78a;
        color: #b94f03;
    }

    &.status-O {
        background: #ECCFFF;
        color: #694382;
    }

}

</style>
